/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MessageRole } from "./MessageRole";
import { ThreadId } from "../../commons/types/ThreadId";
export const MessageApiUpdateData = core.serialization.object({
    messageId: core.serialization.string().optional(),
    content: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    parts: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    annotations: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    role: MessageRole.optional(),
    state: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    threadId: ThreadId.optional(),
});
